module.exports = __webpack_public_path__ + "images/Rutube.ae8df86d30f7c683c3c3b42ce847e1fd.png";